import React from "react";
import { Document, Page } from "@react-pdf/renderer";
import { Row, Col, Typography } from "antd";

const coveredArea = (data) => {
  let coveredAreaString = "Covered Area: ";
  if (data?.floorCoveredAreas?.rccCommercial > 0) {
    coveredAreaString = coveredAreaString.concat(
      `${data?.floorCoveredAreas?.rccCommercial} Sq. ft. Commercial(RCC)`
    );
  }
  if (data?.floorCoveredAreas?.nonRccCommercial > 0) {
    if (data?.floorCoveredAreas?.rccCommercial > 0) {
      coveredAreaString = coveredAreaString.concat(", ");
    }
    coveredAreaString = coveredAreaString.concat(
      `${data?.floorCoveredAreas?.nonRccCommercial} Sq. ft. Commercial(Non-RCC)`
    );
  }
  if (data?.floorCoveredAreas?.rccResidential > 0) {
    if (
      data?.floorCoveredAreas?.rccCommercial > 0 ||
      data?.floorCoveredAreas?.nonRccCommercial > 0
    ) {
      coveredAreaString = coveredAreaString.concat(", ");
    }
    coveredAreaString = coveredAreaString.concat(
      `${data?.floorCoveredAreas?.rccResidential} Sq. ft. Residential(RCC)`
    );
  }
  if (data?.floorCoveredAreas?.nonRccResidential > 0) {
    if (
      data?.floorCoveredAreas?.rccCommercial > 0 ||
      data?.floorCoveredAreas?.nonRccCommercial > 0 ||
      data?.floorCoveredAreas?.rccResidential > 0
    ) {
      coveredAreaString = coveredAreaString.concat(", ");
    }
    coveredAreaString = coveredAreaString.concat(
      `${data?.floorCoveredAreas?.nonRccResidential} Sq. ft. Residential(Non-RCC)`
    );
  }
  return <Typography.Title level={4}>{coveredAreaString}</Typography.Title>;
};

const PropertyPhTenBacksidePdf = ({ data }) => (
  <Document>
    <Page pageNumber={1} wrap>
      {/* <View style={{ ...styles.page }}>hiiiiiiiiiiiiiii</View> */}
      <Typography.Title>ATV Calculations</Typography.Title>
      <Typography.Title level={2} style={{ marginTop: "5%" }}>
        ATV = 1% of Land Value + x% of Structure Value
      </Typography.Title>
      <Typography.Title level={3}>
        where x is 2 for RCC and 0.5 for Non-RCC
      </Typography.Title>
      <Typography.Title level={3} style={{ marginTop: "5%" }}>
        Land Value = Land Area (in Marla) x DC Rate
      </Typography.Title>
      <Typography.Title level={3}>
        Structure Value = Structure Area (in Sq ft.) x Structure Rate
      </Typography.Title>
      <Typography.Title level={4} style={{ marginTop: "5%" }}>
        {data?.landAreas?.commercial > 0 && data?.landAreas.residential > 0
          ? `Land Area: ${data?.landAreas?.commercial} Marlas Commercial, ${data?.landAreas.residential} Marlas Residential`
          : (data?.landAreas?.commercial > 0 &&
              `Land Area: ${data?.landAreas?.commercial} Marlas Commercial`) ||
            (data?.landAreas.residential > 0 &&
              `Land Area: ${data?.landAreas?.residential} Marlas Residential`)}
      </Typography.Title>
      <Typography.Title level={4}>
        {data?.dcRates.filter((e) => e.type === "RESIDENTIAL").length > 0 &&
        data?.dcRates.filter((e) => e.type === "COMMERCIAL").length > 0
          ? `DC Rates used: ${
              data?.dcRates?.[
                data?.dcRates.findIndex((e) => e.type === "COMMERCIAL")
              ]?.dcRate
            } for Commercial, ${
              data?.dcRates?.[
                data?.dcRates.findIndex((e) => e.type === "RESIDENTIAL")
              ]?.dcRate
            } for Residential`
          : (data?.dcRates.filter((e) => e.type === "RESIDENTIAL").length > 0 &&
              `DC Rates used: ${
                data?.dcRates?.[
                  data?.dcRates.findIndex((e) => e.type === "RESIDENTIAL")
                ]?.dcRate
              } for Residential`) ||
            (data?.dcRates.filter((e) => e.type === "COMMERCIAL").length > 0 &&
              `DC Rates used: ${
                data?.dcRates?.[
                  data?.dcRates.findIndex((e) => e.type === "COMMERCIAL")
                ]?.dcRate
              } for Commercial`)}
      </Typography.Title>
      {coveredArea(data)}
      <Typography.Title level={4}>
        {data?.structureRates.filter((e) => e.type === "RESIDENTIAL").length >
          0 &&
        data?.structureRates.filter((e) => e.type === "COMMERCIAL").length > 0
          ? `Structure Rates used: ${
              data?.structureRates?.[
                data?.structureRates.findIndex((e) => e.type === "COMMERCIAL")
              ]?.structureRate
            } for Commercial, ${
              data?.structureRates?.[
                data?.structureRates.findIndex((e) => e.type === "RESIDENTIAL")
              ]?.structureRate
            } for Residential`
          : (data?.structureRates.filter((e) => e.type === "RESIDENTIAL")
              .length > 0 &&
              `Structure Rates used: ${
                data?.structureRates?.[
                  data?.structureRates.findIndex(
                    (e) => e.type === "RESIDENTIAL"
                  )
                ]?.structureRate
              } for Residential`) ||
            (data?.structureRates.filter((e) => e.type === "COMMERCIAL")
              .length > 0 &&
              `Structure Rates used: ${
                data?.structureRates?.[
                  data?.structureRates.findIndex((e) => e.type === "COMMERCIAL")
                ]?.structureRate
              } for Commercial`)}
      </Typography.Title>
      <Typography.Title level={5} style={{ marginTop: "5%" }}>
        {data?.landAreas?.commercial > 0 && data?.landAreas.residential > 0
          ? `ATV = 1% (${data?.landAreas?.commercial} x ${
              data?.dcRates?.[
                data?.dcRates.findIndex((e) => e.type === "COMMERCIAL")
              ]?.dcRate
            } (C) + ${data?.landAreas.residential} x ${
              data?.dcRates?.[
                data?.dcRates.findIndex((e) => e.type === "RESIDENTIAL")
              ]?.dcRate
            } (R))`
          : (data?.landAreas?.commercial > 0 &&
              `ATV = 1% (${data?.landAreas?.commercial} x ${
                data?.dcRates?.[
                  data?.dcRates.findIndex((e) => e.type === "COMMERCIAL")
                ]?.dcRate
              } (C))`) ||
            (data?.landAreas.residential > 0 &&
              `ATV = 1% (${data?.landAreas.residential} x ${
                data?.dcRates?.[
                  data?.dcRates.findIndex((e) => e.type === "RESIDENTIAL")
                ]?.dcRate
              } (R))`)}
      </Typography.Title>
      {data?.floorCoveredAreas?.rccCommercial +
        data?.floorCoveredAreas?.rccResidential >
      0 ? (
        <>
          <Typography.Title level={5}>+</Typography.Title>
          <Typography.Title level={5}>
            {data?.floorCoveredAreas?.rccCommercial > 0 &&
            data?.floorCoveredAreas?.rccResidential > 0
              ? `2% (${data?.floorCoveredAreas?.rccCommercial} (C) x ${
                  data?.structureRates?.[
                    data?.structureRates.findIndex(
                      (e) => e.type === "COMMERCIAL"
                    )
                  ]?.structureRate
                } + ${data?.floorCoveredAreas?.rccResidential} x ${
                  data?.structureRates?.[
                    data?.structureRates.findIndex(
                      (e) => e.type === "RESIDENTIAL"
                    )
                  ]?.structureRate
                } (R))`
              : (data?.floorCoveredAreas?.rccCommercial > 0 &&
                  `2% (${data?.floorCoveredAreas?.rccCommercial} x ${
                    data?.structureRates?.[
                      data?.structureRates.findIndex(
                        (e) => e.type === "COMMERCIAL"
                      )
                    ]?.structureRate
                  } (C))`) ||
                (data?.floorCoveredAreas?.rccResidential > 0 &&
                  `2% (${data?.floorCoveredAreas?.rccResidential} x ${
                    data?.structureRates?.[
                      data?.structureRates.findIndex(
                        (e) => e.type === "RESIDENTIAL"
                      )
                    ]?.structureRate
                  } (R))`)}
          </Typography.Title>
        </>
      ) : null}
      {data?.floorCoveredAreas?.nonRccCommercial +
        data?.floorCoveredAreas?.nonRccResidential >
      0 ? (
        <>
          <Typography.Title level={5}>+</Typography.Title>
          <Typography.Title level={5}>
            {data?.floorCoveredAreas?.nonRccCommercial > 0 &&
            data?.floorCoveredAreas?.nonRccResidential > 0
              ? `0.5% (${data?.floorCoveredAreas?.nonRccCommercial} (C) x ${
                  data?.structureRates?.[
                    data?.structureRates.findIndex(
                      (e) => e.type === "COMMERCIAL"
                    )
                  ]?.structureRate
                } + ${data?.floorCoveredAreas?.nonRccResidential} x ${
                  data?.structureRates?.[
                    data?.structureRates.findIndex(
                      (e) => e.type === "RESIDENTIAL"
                    )
                  ]?.structureRate
                } (R))`
              : (data?.floorCoveredAreas?.nonRccCommercial > 0 &&
                  `0.5% (${data?.floorCoveredAreas?.nonRccCommercial} x ${
                    data?.structureRates?.[
                      data?.structureRates.findIndex(
                        (e) => e.type === "COMMERCIAL"
                      )
                    ]?.structureRate
                  } (C))`) ||
                (data?.floorCoveredAreas?.nonRccResidential > 0 &&
                  `0.5% (${data?.floorCoveredAreas?.nonRccResidential} x ${
                    data?.structureRates?.[
                      data?.structureRates.findIndex(
                        (e) => e.type === "RESIDENTIAL"
                      )
                    ]?.structureRate
                  } (R))`)}
          </Typography.Title>
        </>
      ) : null}
      <Typography.Text type="secondary">
        C: Commercial, R: Residential
      </Typography.Text>
    </Page>
  </Document>
);

export default PropertyPhTenBacksidePdf;
